import { configureStore } from "@reduxjs/toolkit";
import appReducer from "./slices/appSlice";
import contactReducer from "./slices/contactSlice";
import authReducer from "./slices/authSlice";
import profileReducer from "./slices/profileSlice";
import ComparisonReducer from "./slices/comparison.Slice";
import searchReducer from "./slices/searchSlice";
import investmentReducer from "./slices/investmentSlice";
import postdetailsReducer from "./slices/postdetailsSlice";
import editPostReducer from "./slices/editPostSlice";
import salariesReducer from "./slices/salariesSlice";
import testimonyReducer from "./slices/testimonySlice";
import homeInsuranceReducer from "./slices/homeInsuranceSlice";
import LifeInsuranceReducer from "./slices/lifeinsuranceSlice";
import jobsReducer from "./slices/jobsSlice";
import referalReducer from "./slices/referalSlice";
import subscriptionReducer from "./slices/subscriptionSlice";
import subscriptionPaymentReducer from "./slices/subscriptionPaymentSlice";
import careerReducer from "./slices/careerinfoSlice";
import activityReducer from "./slices/trackActivitySlice";
import cityComparisonReducer from "./slices/cityComparisonSlice";
import shopReducer from "./slices/shopSlice";
import shopTrackingReducer from "./slices/shopTrackingSlice";
import notificationReducer from "./slices/notificationSlice";
import communityReducer from "./slices/communitySlice";
import communityAllowanceReducer from "./slices/communityAllowanceSlice";
import paycheckReducer from "./slices/paycheckSlice";

export const store = configureStore({
  reducer: {
    app: appReducer,
    contact: contactReducer,
    auth: authReducer,
    profile: profileReducer,
    comparison: ComparisonReducer,
    search: searchReducer,
    investment: investmentReducer,
    postDetail: postdetailsReducer,
    editPost: editPostReducer,
    salaries: salariesReducer,
    testimony: testimonyReducer,
    homeInsurance: homeInsuranceReducer,
    lifeInsurance: LifeInsuranceReducer,
    jobResults: jobsReducer,
    referalData: referalReducer,
    subscriptionData: subscriptionReducer,
    subscriptionPayment: subscriptionPaymentReducer,
    career: careerReducer,
    activity: activityReducer,
    cityComparison: cityComparisonReducer,
    shop: shopReducer,
    shopTracking: shopTrackingReducer,
    notification: notificationReducer,
    community: communityReducer,
    communityAllowance: communityAllowanceReducer,
    paycheck: paycheckReducer,
  },
});

export default store;
